module.exports = __webpack_public_path__ + "static/media/buildingConstruction37.00f254cd.jpg";